import TableSummaryDefault from '../../lib/jin/svgchartlib/02_PageComponents/02_SummaryTable/includes/primitives/Data'

export default TableSummaryDefault